import { render, staticRenderFns } from "./ranking-toy2.vue?vue&type=template&id=d879cce8&scoped=true&"
import script from "./ranking-toy2.vue?vue&type=script&lang=js&"
export * from "./ranking-toy2.vue?vue&type=script&lang=js&"
import style0 from "./ranking-toy2.vue?vue&type=style&index=0&id=d879cce8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d879cce8",
  null
  
)

export default component.exports